export default "__VITE_ASSET__BOlEgPYj__"